import {OFFLINE_STORES, getOfflineStorageDriver} from './offlineStorageAdapter.js';
import {withVisitaLocalLock} from './visitaLocalFirst.js';

// Se conserva la intención hasta guardar el reparto confirmado en su contexto.
export async function acknowledgeVisitaSplit(operation, receipt, empresaId, {driver=getOfflineStorageDriver()}={}) {
    if (receipt?.success !== true || receipt.applied_operation_uuid !== operation.operation_uuid
        || Number(receipt.visita_id) !== Number(operation.visitaId) || Number(receipt.user_id) !== Number(operation.userId)
        || Number(receipt.empresa_id) !== Number(empresaId) || Number(receipt.secciones_total) < 2
        || !Number.isSafeInteger(receipt.responses_version) || !receipt.mi_seccion_catalogo
        || !receipt.instance_owners || !receipt.partes_distribuidas) throw Error('Falta el recibo exacto del reparto. Solicitud conservada.');
    return withVisitaLocalLock(operation.userId, operation.visitaId, async () => {
        await driver.init();
        const rows = (await driver.getAll(OFFLINE_STORES.CONTEXTS, null, {userId: Number(operation.userId), contexts:{visitaId:Number(operation.visitaId)}}))
            .filter(row => row.kind === 'context' && row.userId === Number(operation.userId)
                && row.empresaId === Number(empresaId) && row.visitaId === Number(operation.visitaId));
        if (!rows.length) throw Error('No se encontró la copia preparada para conservar el reparto. Solicitud retenida.');
        for (const row of rows) {
            const saved = await driver.mutate(OFFLINE_STORES.CONTEXTS, row.id, current => {
                if (current?.version !== row.version) return null;
                if (current.context?.visita?.catalogo_dividido && Number(current.context.visita.responses_version) > receipt.responses_version) return current;
                return {...current, version:crypto.randomUUID(), context:{...current.context,
                    visita:{...current.context.visita,catalogo_dividido:true,instance_owners:receipt.instance_owners,
                        responses_version:Math.max(Number(current.context.visita.responses_version || 0),receipt.responses_version)},
                    context:{...current.context.context,partes_distribuidas:receipt.partes_distribuidas,mi_seccion_catalogo:receipt.mi_seccion_catalogo},
                    permissions:{...current.context.permissions,can_split_work:false,can_split_work_active:true},
                }};
            });
            if (!saved) throw Error('La copia preparada cambió al confirmar el reparto. Solicitud retenida.');
        }
        return true;
    });
}
